import { createFileRoute } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { CompanyTracingOrdersTab } from '../../../-components/CompanyTracingOrdersTab';
import { companyTracingOrdersQueryOptions } from '../../../-hooks/useCompanyTracingOrders';
import { DEFAULT_PAGE_SIZE } from '../../../-utils/pagination';

export const Route = createFileRoute(
  '/management/companies/(pages)/$companyId/tracing-orders/',
)({
  loader: ({ params }) =>
    queryClient
      .ensureQueryData(
        companyTracingOrdersQueryOptions({
          companyId: params.companyId,
          page: 1,
          limit: DEFAULT_PAGE_SIZE,
        }),
      )
      // A failed prefetch must not blank the tab — the component's own query
      // re-runs and surfaces the error inline.
      .catch(() => undefined),
  component: CompanyTracingOrdersPage,
});

function CompanyTracingOrdersPage() {
  const { companyId } = Route.useParams();
  return <CompanyTracingOrdersTab companyId={companyId} />;
}
